import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminRoute } from './components/AdminRoute';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { NewGenerationPage } from './pages/NewGenerationPage';
import { GenerationDetailPage } from './pages/GenerationDetailPage';
import { PromptSelectionPage } from './pages/PromptSelectionPage';
import { AdminFeedbacksPage } from './pages/AdminFeedbacksPage';
import { AdminUsersPage } from './pages/AdminUsersPage';
import { PaymentPage } from './pages/PaymentPage';
import { SuccessPage } from './pages/SuccessPage';
import { VerifyEmailPage } from './pages/VerifyEmailPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';

function AppRoutes() {
  const { user, loading, emailVerified } = useAuth();

  if (loading) {
    return null;
  }

  // Allow unverified email/password users to stay on login page
  const isGoogleUser = user?.providerData.some(p => p.providerId === 'google.com');
  const isFullyAuthenticated = user && (isGoogleUser || emailVerified);

  return (
    <Routes>
      <Route
        path="/login"
        element={isFullyAuthenticated ? <Navigate to="/" replace /> : <LoginPage />}
      />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/new"
        element={
          <ProtectedRoute>
            <NewGenerationPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/generation/:id/prompts"
        element={
          <ProtectedRoute>
            <PromptSelectionPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/generation/:id"
        element={
          <ProtectedRoute>
            <GenerationDetailPage />
          </ProtectedRoute>
        }
      />
      <Route path="/preview/:id" element={<Navigate to="/" replace />} />
      <Route
        path="/buy-credits"
        element={
          <ProtectedRoute>
            <PaymentPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/success"
        element={
          <ProtectedRoute>
            <SuccessPage />
          </ProtectedRoute>
        }
      />
      <Route path="/history" element={<Navigate to="/" replace />} />
      <Route
        path="/admin/feedbacks"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminFeedbacksPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminUsersPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
